import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ImagePaths } from "../../utils/ImagePaths";
import SuccessGif from "../../assets/animation/Success.gif";
import { AuthSubmitButton } from "../../components/ui/form-fields";

const PasswordSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user_name } = location.state || {};

  return (
    <div className="h-screen flex items-center justify-center relative bg-background font-sans transition-colors">
      <div
        className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')]
    bg-cover bg-center opacity-10 dark:opacity-20"
      />

      <div className="absolute inset-0 bg-white/40 dark:bg-black/40 backdrop-blur-sm transition-colors" />

      <div className="w-full max-w-sm relative z-10">
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        <div className="bg-card/95 backdrop-blur-md rounded-xl shadow-xl p-6 text-center animate-fadeIn border border-border transition-colors">
          <img
            src={SuccessGif}
            alt="Success"
            className="w-24 h-24 mx-auto mb-4 rounded-full"
          />

          <p className="text-lg font-semibold text-foreground mb-2">
            Congratulations {user_name || "User"}!
          </p>

          <p className="text-sm text-muted-foreground mb-6">
            Your password has been changed successfully.
          </p>

          <AuthSubmitButton type="button" onClick={() => navigate("/")}>
            Back to Login
          </AuthSubmitButton>
        </div>
      </div>
    </div>
  );
};

export default PasswordSuccess;
